import { apiPut, mockSuccess } from "@redriver/cinnamon";

const NAMESPACE = "TERMS";
export const ActionTypes = {
  AgreeToTerms: `${NAMESPACE}/AGREE_TO_TERMS`,
};

export const agreeToTerms = () =>
  apiPut(ActionTypes.AgreeToTerms, "resort-reps/contract-terms");
